import * as React from 'react';
import { createSource, source } from "./context";
import { UID } from "./UIDComponent";
export var UIDReset = function (_a) {
    var children = _a.children;
    return (React.createElement(source.Provider, { value: createSource() }, children));
};
export var UIDFork = function (_a) {
    var children = _a.children;
    return (React.createElement(UIDConsumer, null, function (id) { return (React.createElement(source.Provider, { value: createSource(id + '-') }, children)); }));
};
export var UIDConsumer = function (_a) {
    var name = _a.name, children = _a.children;
    return (React.createElement(source.Consumer, null, function (value) { return (React.createElement(UID, { name: name, idSource: value, children: children })); }));
};
